import { useState, useContext, useEffect } from "react";
import { v4 } from "uuid";
import { EditableFormContext } from "./EditProvider.js";
function useEditButton({ mode, isMultiStep, onCancel, onEdit, onSave, onNextStep, onEditModeChange }) {
  const [currentMode, setCurrentMode] = useState(mode);
  const [currentId] = useState(v4());
  const { editableFormId, setEditableFormId } = useContext(EditableFormContext);
  useEffect(() => {
    if (currentMode !== mode) {
      setEditMode(mode);
      if (isEditable(mode)) {
        setEditableFormId(currentId);
      }
    }
  }, [mode]);
  useEffect(() => {
    if (currentId !== editableFormId) {
      setEditMode("Read");
    } else {
      setEditMode(isMultiStep ? "EditMultiStep" : "Edit");
    }
  }, [editableFormId]);
  function isEditable(mode2) {
    return mode2 === "EditMultiStep" || mode2 === "Edit";
  }
  function handleCancel() {
    setEditMode("Read");
    if (onCancel) {
      onCancel();
    }
  }
  function handleSave() {
    setEditMode("InProgress");
    onSave();
  }
  function handleEdit() {
    setEditableFormId(currentId);
    if (onEdit) {
      onEdit();
    }
  }
  function handleNextStep() {
    if (onNextStep) {
      onNextStep();
    }
  }
  function setEditMode(mode2) {
    setCurrentMode(mode2);
    if (onEditModeChange) {
      onEditModeChange(mode2);
    }
  }
  return {
    handleCancel,
    handleSave,
    handleEdit,
    handleNextStep,
    currentMode
  };
}
export {
  useEditButton
};
//# sourceMappingURL=hooks.js.map
